
/**
 An encapsulation of HTML radio button groups.
 [public methods]
 getValue(): get the currently selected value in the group (a string)
 setValue(newValue): change the currently selected value in the group
 setEnabled(enabled): enable or disable all options in the group.
 getOption(): get the the 'Radio' object for the specified option value.

 Example:
 If you have a set of radio options in a form, each named "group1", you can use the object as follows:

 let grp = new RadioGroup(document.MyForm.group1);
 alert(grp.getValue());
 grp.setValue("optionA");
 grp.setEnabled(false);
 */
export class RadioGroup {
    constructor(radioGroup) {
        this.group = radioGroup;
    }

    /*Radio groups with only 1 option are not represented as an array.  This inconsistency is
      inconvenient.  This function presents any number of options as an array.*/
    getArray() {
        if (typeof this.group.length == "undefined")
            return new Array(this.group);
        else
            return this.group;
    }

    getValue() {
        let options = this.getArray();
        for (let i = 0; i < options.length; i++) {
            if (options[i].checked)
                return options[i].value;
        }
        return null;
    };

    setValue(value) {
        let options = this.getArray();

        for (let i = 0; i < options.length; i++)
            options[i].checked = options[i].value === value;
    };

    setEnabled(enabled) {
        let options = this.getArray();
        for (let i = 0; i < options.length; i++)
            options[i].disabled = !enabled;
    };

    getOption(value) {
        let options = this.getArray();
        for (let i = 0; i < options.length; i++) {
            if (options[i].value === value)
                return options[i];
        }
        return null;
    };
}